import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type FpoConfirmationType =
  | 'delete'
  | 'warning'
  | 'success'
  |'signin'

export interface FpoConfirmValues {
  title: string;
  message: string;
  cancelText?: string;
  confirmText?: string;
  type?: FpoConfirmationType;
}

@Component({
  selector: 'app-fpo-confirmation-dialog',
  templateUrl: './fpo-confirmation-dialog.component.html',
  styleUrls: ['./fpo-confirmation-dialog.component.css']
})
export class FpoConfirmationDialogComponent implements OnInit {

@Input() confirmValues: FpoConfirmValues = {
  title: 'Are you sure?',
  message: '',
  cancelText: 'Cancel',
  confirmText: 'Confirm',
  type: 'warning'
};

@Input() loading = false;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
  }

   onConfirm(): void {

    if (this.loading) {
      return;
    }

    this.activeModal.close({
      success: true
    });
  }


  onCancel(): void {

    if (this.loading) {
      return;
    }

    this.activeModal.dismiss({
      success: false
    });
  }


  get iconClass(): string {

    switch (this.confirmValues.type) {

      case 'delete':
        return 'fa-trash-alt';

      case 'success':
        return 'fa-check-circle';

      case 'signin':
        return 'fa-sign-in-alt';

      default:
        return 'fa-exclamation-circle';
    } 
  }

}
